'use client';

import { fetchViaProxy } from '@/actions/proxy-fetch';
import Dialog from '@/components/next-ui/Dialog';
import useUserProfile from '@/hooks/useUserProfile';
import { useQuery } from '@tanstack/react-query';
import React from 'react';
import ContributorCard from './ContributorCard';
import {
  Tab,
  TabPanel,
  TabPanels,
  Tabs,
  TabsList,
} from '@/components/next-ui/Tab';
import Spinner from '../Spinner';
import NonProfitCard from '../NonProfitCard';
import NonProfitExploreCard from '../NonProfitExploreCard';

function UserConnectionsDialog(props) {
  const { open, onClose } = props;
  const userProfile = useUserProfile();
  const { data, isLoading } = useQuery({
    queryKey: ['my-connections', userProfile?.activeCommunity?.id],
    queryFn: async () => {
      const { ok, data } = await fetchViaProxy(
        '/proxy/v2/protected/users/me/connections?view=all',
      );

      if (ok) {
        return data;
      }
      throw new Error('Failed to fetch top contributors');
    },
  });

  const connections = data?.connections || [];

  const users = connections.filter((c) => c.type === 'user');
  const communities = connections.filter((c) => c.type === 'npo');

  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog
      isOpen={open}
      maxWidth="lg"
      title="All Connections"
      contentClass="p-0 lg:p-0 bg-body-background lg:bg-white overflow-y-auto"
      titleClass="pb-2"
      onClose={() => handleClose()}>
      <div className="flex h-full w-full flex-col px-0 py-4 sm:px-4 md:px-6 lg:px-8">
        {isLoading ? (
          <div className="flex items-center justify-center">
            <Spinner size="lg" />
          </div>
        ) : (
          <Tabs>
            <TabsList className="flex justify-start space-x-1">
              <Tab>People</Tab>
              <Tab>Communities</Tab>
            </TabsList>
            <TabPanels>
              <TabPanel className="flex w-full flex-col items-start justify-start pb-2">
                <div className="flex w-full flex-col py-4">
                  <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 sm:gap-8 lg:grid-cols-3">
                    {users?.map((user) => (
                      <ContributorCard key={user.id} user={user} />
                    ))}
                  </div>
                </div>
              </TabPanel>
              <TabPanel className="flex flex-col items-start justify-start pb-2">
                <div className="flex w-full flex-col py-4">
                  <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 sm:gap-8 lg:grid-cols-3">
                    {communities?.map((community) => (
                      <NonProfitExploreCard key={community.id} nonProfit={community} />
                    ))}
                  </div>
                </div>
              </TabPanel>
            </TabPanels>
          </Tabs>
        )}
      </div>
    </Dialog>
  );
}

export default React.memo(UserConnectionsDialog);
